"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModal = exports.Modal = void 0;
var tslib_1 = require("tslib");
var Modal_1 = require("@reactionable/core/lib/ui/modal/Modal");
var react_1 = tslib_1.__importStar(require("react"));
var Modal_2 = tslib_1.__importDefault(require("react-bootstrap/Modal"));
exports.Modal = function (_a) {
    var title = _a.title, children = _a.children, body = _a.body, footer = _a.footer, onHide = _a.onHide, modalProps = tslib_1.__rest(_a, ["title", "children", "body", "footer", "onHide"]);
    var _b = tslib_1.__read(react_1.useState(true), 2), show = _b[0], setShow = _b[1];
    var handleOnClose = function () {
        setShow(false);
        onHide && onHide();
    };
    return (react_1.default.createElement(Modal_2.default, tslib_1.__assign({ centered: true, show: show, backdrop: "static", onHide: handleOnClose }, modalProps),
        react_1.default.createElement(Modal_2.default.Header, { closeButton: true },
            react_1.default.createElement(Modal_2.default.Title, null, title)),
        children,
        body && react_1.default.createElement(Modal_2.default.Body, null, body),
        footer && react_1.default.createElement(Modal_2.default.Footer, null, footer)));
};
function useModal(props) {
    return Modal_1.useModal(tslib_1.__assign({ Component: exports.Modal }, props));
}
exports.useModal = useModal;
//# sourceMappingURL=Modal.js.map